// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3V0FD","productName":"Table_productName__1IkDI"};